import { useContext } from "react";
import { useSelector } from "react-redux";
import { PersonalSynthesis } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  synthesis: PersonalSynthesis;
  retrievePersonalSynthesis(
    request: Boundaries["retrievePersonalSynthesis"]["request"],
  ): void;
}

function useRetrievePersonalSynthesis(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isPersonalSynthesisRetrievalRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isPersonalSynthesisRetrievalRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isPersonalSynthesisRetrievalRequestFailure,
    ),
    synthesis: useSelector(selector.getPersonalSynthesis),
    retrievePersonalSynthesis: core.retrievePersonalSynthesis,
  };
}

export { useRetrievePersonalSynthesis };
